export const COMMON = {
  error: "An error occurred, please try again!",
  session_timeout: "Session timeout. Please login again!",
};
